import { V1_ANNOUNCEMENTS_PATH } from '@/constant/routers/path';
import request from '@/services/http.service';
import type { AnnouncementDetailResponse, AnnouncementListResponse } from '@/types/announcement';

export const getAnnouncements = (): Promise<AnnouncementListResponse> => {
  return request(V1_ANNOUNCEMENTS_PATH, {
    method: 'GET',
  });
};

export const getAnnouncementDetail = (id: number | string): Promise<AnnouncementDetailResponse> => {
  return request(`${V1_ANNOUNCEMENTS_PATH}/${id}`, {
    method: 'GET',
  });
};
